import { useNuxtData } from '#app'
import { computed } from 'vue'

import { brandingAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { omit } from '@backmarket/utils/object/omit'

export function useSkinnyBannerLoader() {
  /**
   * fetches skinny banner data from the API and loads it in Nuxt cache
   */
  const loadSkinnyBannerData = () =>
    useHttpFetch(brandingAPI.getSkinnyBanner, {
      getCachedData: (key) => {
        return useNuxtData(key).data.value || undefined
      },
    })

  function useLoadedData(page: string, id?: number | null) {
    const { data } = loadSkinnyBannerData()

    return computed(() => {
      let banners = (data.value || []).filter(({ locations = [] }) =>
        locations.includes(page),
      )
      if (id) {
        banners = banners.filter(({ id: bannerId }) => bannerId === id)
      }

      const [bannerToDisplay = null] = banners

      return bannerToDisplay ? omit(bannerToDisplay, ['locations', 'id']) : null
    })
  }

  const load = loadSkinnyBannerData

  return {
    load,
    useLoadedData,
  }
}
